module.exports = __webpack_public_path__ + "static/media/06.6d3d6469.jpg";